<template>
  <div>
    <el-table :data="apis" :stripe="true" size="mini" ref="table" v-loading="loading">
      <el-table-column type="selection" width="55" v-if="checkable"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="method" label="请求方法" :sortable="true"></el-table-column>
      <el-table-column prop="url" label="请求地址" :sortable="true"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'api-manage',
  props: {
    checkable: {type: Boolean, require: false, default: false},
    roleId: {type: Number, require: false, default: 0}
  },
  data () {
    return {
      loading: false,
      apis: []
    }
  },
  created () {
    this.load()
  },
  watch: {
    'roleId' () {
      this.load()
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgApis?roleId=${this.roleId}`
      }).then((res) => {
        this.apis = res.data.data
        this.loading = false

        if (this.roleId) {
          this.$nextTick(() => {
            this.apis.forEach(api => {
              if (api.roleId === this.roleId) {
                this.$refs.table.toggleRowSelection(api)
              }
            })
          })
        }
      })
    },
    getSelection () {
      let toAdds = []
      let temp = {}
      let selection = this.$refs.table.selection
      for (let selected of selection) {
        if (!selected.roleId) {
          toAdds.push(selected.apiId)
        }
        temp[selected.apiId] = selected
      }
      let toDeletes = []
      let apis = this.apis
      for (let api of apis) {
        if (api.roleId && !temp[api.apiId]) {
          toDeletes.push(api.apiId)
        }
      }

      return {toAdds: toAdds, toDeletes: toDeletes}
    }
  }
}
</script>
